import React from 'react';
import { Link } from 'react-router-dom'; // Add this import
import Header from '../components/Header';
import Footer from '../components/Footer';
// Remove Footer import since it's not used

export default function Pricing() {
  const pricingPlans = [
    {
      name: 'Donor',
      description: 'For individuals who want to support causes',
      price: 'Free',
      features: [
        'Make donations to any campaign',
        'No additional fees',
        'Secure payment processing',
        'Tax deductible receipts',
        'Email updates on campaigns'
      ],
      popular: false,
      buttonText: 'Start Donating',
      buttonLink: '/'
    },
    {
      name: 'Fundraiser',
      description: 'For individuals and organizations raising funds',
      price: '3%',
      subtext: 'platform fee',
      features: [
        'Create unlimited campaigns',
        '3% platform fee on all payments',
        'Social media integration',
        'Real-time donation tracking',
        'Customizable campaign pages',
        'Donor management tools',
        'Email support'
      ],
      popular: true,
      buttonText: 'Start Fundraising',
      buttonLink: '/raisefunds'
    },
    {
      name: 'Organization',
      description: 'For non-profits and registered charities',
      price: '3%',
      subtext: 'platform fee*',
      features: [
        'All Fundraiser features',
        'Reduced 3% platform fee*',
        'Bulk donor management',
        'Advanced analytics',
        'Custom branding',
        'Team collaboration',
        'Priority support',
        'API access'
      ],
      popular: false,
      buttonText: 'Contact Sales',
      buttonLink: '/contactus'
    }
  ];

  return (
  <div style={{ fontFamily: 'Arial, sans-serif', backgroundColor: '#fdfaf6', color: '#333' }}>
      {/* Header Section */}
      <Header/>
      <div style={styles.header}>
        <h1 style={styles.title}>Simple, Transparent Pricing</h1>
        <p style={styles.subtitle}>
          Join thousands of donors and fundraisers on Donorji. 
          <br />No hidden fees. No surprises.
        </p>
        
        {/* Platform Fee Banner */}
        <div style={styles.feeBanner}>
          <div style={styles.feeContent}>
            <span style={styles.feeIcon}>💎</span>
            <div>
              <h3 style={styles.feeTitle}>Low Platform Fee</h3>
              <p style={styles.feeText}>Only 3% platform fee for all payments + payment processor fees</p>
            </div>
          </div>
        </div>
      </div>

      {/* Pricing Cards */}
      <div style={styles.pricingGrid}>
        {pricingPlans.map((plan, index) => (
          <div 
            key={index} 
            style={{
              ...styles.pricingCard,
              ...(plan.popular ? styles.popularCard : {})
            }}
          >
            {/* Popular Badge */}
            {plan.popular && (
              <div style={styles.popularBadge}>
                Most Popular
              </div>
            )}

            {/* Plan Header */}
            <div style={styles.cardHeader}>
              <h3 style={styles.planName}>{plan.name}</h3>
              <p style={styles.planDescription}>{plan.description}</p>
              
              {/* Price */}
              <div style={styles.priceSection}>
                <span style={styles.price}>{plan.price}</span>
                {plan.subtext && (
                  <span style={styles.priceSubtext}>/{plan.subtext}</span>
                )}
              </div>
            </div>

            {/* Features List */}
            <ul style={styles.featuresList}>
              {plan.features.map((feature, featureIndex) => (
                <li key={featureIndex} style={styles.featureItem}>
                  <span style={styles.checkmark}>✓</span>
                  {feature}
                </li>
              ))}
            </ul>

            {/* Action Button */}
            <Link 
              to={plan.buttonLink}
              style={{
                ...styles.ctaButton,
                ...(plan.popular ? styles.popularButton : {})
              }}
            >
              {plan.buttonText}
            </Link>
          </div>
        ))}
      </div>

      {/* Additional Information */}
      <div style={styles.infoSection}>
        <div style={styles.infoGrid}>
          <div style={styles.infoCard}>
            <h4 style={styles.infoTitle}>💳 Payment Processing</h4>
            <p style={styles.infoText}>
              Additional payment processor fees (Stripe/PayPal) apply based on your location and payment method.
            </p>
          </div>
          
          <div style={styles.infoCard}>
            <h4 style={styles.infoTitle}>🔒 Secure & Trusted</h4>
            <p style={styles.infoText}>
              Bank-level security for all transactions. Your donors' information is always protected.
            </p>
          </div>
          
          <div style={styles.infoCard}>
            <h4 style={styles.infoTitle}>🎯 No Hidden Costs</h4>
            <p style={styles.infoText}>
              What you see is what you pay. No setup fees, monthly fees, or hidden charges.
            </p>
          </div>
        </div>

        {/* Footnote 
        // <div style={styles.footnote}>
        //   <p style={styles.footnoteText}>
        //     *2% platform fee available for registered 501(c)(3) non-profits and verified charitable organizations. 
        //     <Link to="/verification" style={styles.footnoteLink}> Learn more about verification</Link>
        //   </p>
        // </div>*/}
      </div>
      <Footer/>
    </div>
  );
}

// All CSS styles in the same file
const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
    padding: '2rem 1rem',
    fontFamily: `'Segoe UI', Tahoma, Geneva, Verdana, sans-serif`
  },
  header: {
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto 3rem auto'
  },
  title: {
    fontSize: '3rem',
    fontWeight: 'bold',
    color: '#1e293b',
    marginBottom: '1rem',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
  },
  subtitle: {
    fontSize: '1.2rem',
    color: '#64748b',
    lineHeight: '1.6',
    marginBottom: '2rem'
  },
  feeBanner: {
    backgroundColor: 'white',
    padding: '1.5rem',
    borderRadius: '12px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    maxWidth: '400px',
    margin: '0 auto'
  },
  feeContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  feeIcon: {
    fontSize: '2rem'
  },
  feeTitle: {
    fontSize: '1.1rem',
    fontWeight: 'bold',
    color: '#1e293b',
    margin: '0 0 0.25rem 0'
  },
  feeText: {
    fontSize: '0.9rem',
    color: '#64748b',
    margin: 0
  },
  pricingGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '2rem',
    maxWidth: '1200px',
    margin: '0 auto 4rem auto'
  },
  pricingCard: {
    backgroundColor: 'white',
    padding: '2rem',
    borderRadius: '16px',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    position: 'relative',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    display: 'flex',
    flexDirection: 'column',
    height: 'fit-content'
  },
  popularCard: {
    transform: 'scale(1.05)',
    border: '2px solid #667eea',
    boxShadow: '0 20px 25px -5px rgba(102, 126, 234, 0.2), 0 10px 10px -5px rgba(102, 126, 234, 0.1)'
  },
  popularBadge: {
    position: 'absolute',
    top: '-12px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#667eea',
    color: 'white',
    padding: '0.5rem 1.5rem',
    borderRadius: '20px',
    fontSize: '0.8rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  cardHeader: {
    textAlign: 'center',
    marginBottom: '2rem'
  },
  planName: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#1e293b',
    margin: '0 0 0.5rem 0'
  },
  planDescription: {
    color: '#64748b',
    margin: '0 0 1.5rem 0',
    fontSize: '0.9rem'
  },
  priceSection: {
    marginBottom: '1rem'
  },
  price: {
    fontSize: '3rem',
    fontWeight: 'bold',
    color: '#667eea',
    lineHeight: '1'
  },
  priceSubtext: {
    fontSize: '1rem',
    color: '#64748b',
    fontWeight: 'normal'
  },
  featuresList: {
    listStyle: 'none',
    padding: 0,
    margin: '0 0 2rem 0',
    flex: 1
  },
  featureItem: {
    padding: '0.5rem 0',
    color: '#475569',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '0.5rem',
    fontSize: '0.95rem'
  },
  checkmark: {
    color: '#10b981',
    fontWeight: 'bold',
    flexShrink: 0
  },
  ctaButton: {
    display: 'block',
    textAlign: 'center',
    backgroundColor: '#667eea',
    color: 'white',
    padding: '1rem 2rem',
    borderRadius: '8px',
    textDecoration: 'none',
    fontWeight: 'bold',
    transition: 'all 0.3s ease',
    border: '2px solid #667eea'
  },
  popularButton: {
    backgroundColor: 'white',
    color: '#667eea'
  },
  infoSection: {
    maxWidth: '1200px',
    margin: '0 auto'
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '1.5rem',
    marginBottom: '2rem'
  },
  infoCard: {
    backgroundColor: 'white',
    padding: '1.5rem',
    borderRadius: '12px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
  },
  infoTitle: {
    fontSize: '1.1rem',
    fontWeight: 'bold',
    color: '#1e293b',
    margin: '0 0 0.5rem 0'
  },
  infoText: {
    color: '#64748b',
    fontSize: '0.9rem',
    lineHeight: '1.5',
    margin: 0
  },
  footnote: {
    textAlign: 'center',
    padding: '1.5rem',
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
  },
  footnoteText: {
    color: '#64748b',
    fontSize: '0.85rem',
    margin: 0
  },
  footnoteLink: {
    color: '#667eea',
    textDecoration: 'none',
    fontWeight: 'bold'
  }
};
